/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { ScenarioTelopStyle } from './scenarioTelopStyle'

export interface ScenarioTelop {
  updatedAt: string
  createdAt: string
  /** @nullable */
  style: ScenarioTelopStyle
  endTime: number
  startTime: number
  text: string
  nodeId: Cuid
  id: Cuid
}
